import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import swal from "sweetalert";
import {
  getShipManagementList,
  getShipManagementDetail,
  getPaintCoating,
  getEquipmentMachinery,
  getStructureAndHull,
  getStores,
  postInventoryDetails,
} from "../Actions/ShipManagementAPI";
import { UploadHKC, UploadEUSSR } from "../Actions/CommonAPI";
import {
  getCompanynameList,
  getClientUsersList,
  getShipDetails,
} from "../Actions/HelpersAPI";
import AddIcon from "../UIComponents/AddIcon";
import DatePicker from "react-datepicker";
import { Paginator } from "primereact/paginator";
import { toast } from "react-toastify";
import { searchShipMgmt } from "../Actions/ShipManagementAPI";
import Moment from "moment";
import axios from "axios";
import API from "../helpers/api";
import { isAction } from "redux";
let user = JSON.parse(localStorage.getItem("currentUser"));

let searchData = {
  ShipName: "",
  PageNumber: 1,
  PageSize: 25,
  isActive: true,
  isInactive: false,
  isAll: false
};

class ShipManagementEditItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchData: {
        Name: "",
      },
      hkcfile: "",
      eussrfile: "",
      hkcFilename: "",
      eussrFilename: "",
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      eussrToDateOpen: false,
      shipData: {
        shipId: 0,
        shipName: "",
        companyName: "",
        imoNo: "",
        flagName: "",
        className: "",
        shipEmail: "",
        vesselGroupEmail: "",
        invoiceForwardingEmail: "",
        phone1: "",
        phone2: "",
        hkcIssuedBy: "",
        hkcIssuedDate: "",
        isDeleted: false,
        modifiedBy: "",
        shipUsers: [],
        isActive: true
      },
      rows: 5,
      fleetManager: "",
      superintendent: "",
      technicalExecutive: "",
      paintAndCoating: [],
      equipmentAndMachinery: [],
      structureAndHull: [],
      store: [],
    };
    this.handleCompanyInputChange = this.handleCompanyInputChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.UpdateData = this.UpdateData.bind(this);

  }

  componentDidMount() {
    const { match, dispatch, companyName, ShipDetails } = this.props;
    const { params } = match;
    const { id } = params;
    dispatch(getShipDetails(id));
    dispatch(getCompanynameList());
    this.props.dispatch(getClientUsersList(companyName));
    dispatch({ type: "SubBannerTitle", data: "Ship Management" });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      dispatch,
      ShipDetails,
    } = nextProps;
    if (ShipDetails && ShipDetails !== "") {

      prevState.shipData.shipId = ShipDetails.shipId;
      prevState.shipData.shipName = ShipDetails.shipName ? ShipDetails.shipName : "";
      prevState.shipData.companyName = ShipDetails.clientName ? ShipDetails.clientName : "";
      prevState.shipData.imoNo = ShipDetails.imoNo ? ShipDetails.imoNo : "";
      prevState.shipData.flagName = ShipDetails.flag;
      prevState.shipData.className = ShipDetails.class;
      prevState.shipData.shipEmail = ShipDetails.shipMail ? ShipDetails.shipMail : "";
      prevState.shipData.isActive = ShipDetails?.isActive ? ShipDetails?.isActive : false;

      prevState.shipData.vesselGroupEmail = ShipDetails.vesselGroupMail;
      // prevState.shipData.vesselGroupEmail = ShipDetails.vesselGroupEmail;
      prevState.shipData.invoiceForwardingEmail =
        ShipDetails.invoiceForwardingEmail;
      prevState.shipData.phone1 = ShipDetails.phone1;
      prevState.shipData.phone2 = ShipDetails.phone2;
      prevState.shipData.modifiedBy = ShipDetails.modifiedBy;
      prevState.fleetManager = ShipDetails.fleetManager;
      prevState.superintendent = ShipDetails.superIntendent;
      prevState.technicalExecutive = ShipDetails.technicalExecutive;
      let Users = [
        {
          userName: ShipDetails.fleetManager,
          role: "fleetmanager",
        },
        {
          userName: ShipDetails.superIntendent,
          role: "superintendent",
        },
        {
          userName: ShipDetails.technicalExecutive,
          role: "technicalexecutive",
        },
      ];
      prevState.shipData.shipUsers = Users;
      dispatch({ type: "getShipManagementDetailSuccess", data: "" });
    }
  }
  vesselmailvalid = () => {
    let flag = true;
    let emailregex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (this.state.shipData.vesselGroupEmail !== '') {
      if (emailregex.test(this.state.shipData.vesselGroupEmail)) {
        flag = true;
      }
      else {
        flag = false;
      }
    }
    return flag;
  }
  UpdateData() {
    let emailregex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const { dispatch } = this.props;
    /* console.log("shipData", this.state.shipData); */
    let inventory = {
      shipId: this.state.shipData.shipId,
      paintAndCoating: this.state.paintAndCoating,
      equipmentAndMachinery: this.state.equipmentAndMachinery,
      structureAndHull: this.state.structureAndHull,
      store: this.state.store,
    };
    if (this.state.shipData.companyName !== "" && this.state.shipData.imoNo !== "" && this.state.shipData.shipName !== "" && this.state.shipData.shipEmail !== "") {
      /* console.log("inventory", inventory); */
      if (emailregex.test(this.state.shipData.shipEmail)) {
        if (this.vesselmailvalid()) {
          let url = `${API.PostShip}`;
          let data = {
            shipId: this.state.shipData.shipId,
            shipName: this.state.shipData.shipName,
            imoNo: this.state.shipData.imoNo,
            shipMail: this.state.shipData.shipEmail,
            vesselGroupMail: this.state.shipData.vesselGroupEmail,
            isDeleted: false,
            modifiedBy: user.email,
            clientName: this.state.shipData.companyName,
            shipUsers: this.state.shipData.shipUsers,
            isActive: this.state.shipData.isActive
          };

          axios
            .put(url, data, {
              headers: {
                key: user.accessToken,
              },
            })
            .then((response) => {
              dispatch(searchShipMgmt(searchData));
              this.CancelUpdateship();
              toast.success("Updated Successfully", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
              dispatch({
                type: "putShipDetailsSuccess",
                data: response.data,
              });
              this.props.history.push("/Home/Management/Ship");
            })
            .catch((error) => {
              swal("Error!", "Something went wrong. Please try again.", "warning");
              dispatch({
                type: "putShipDetailsFailure",
                error: "ERROR",
              });
            });
        }
        else {
          swal("Error!", "Invalid email format(Vessel Email)", "warning");
        }
      }
      else {
        swal("Error!", "Invalid email format(Ship Email)", "warning");
      }
    } else if (this.state.shipData.shipName === "") {
      swal('Error!', 'Ship Name is mandatory', 'warning');
    }
    else if (this.state.shipData.imoNo === "") {
      swal('Error!', 'IMO Number is mandatory', 'warning');
    } else if (this.state.shipData.shipEmail === "") {
      swal("Error!", "Email is mandatory", "warning");
    }
    else if (this.state.shipData.companyName === "") {
      swal("Error!", "Company Name is mandatory", "warning");
    }

  }

  CancelUpdateship() {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/Management/Ship");
  }
  handleCompanyInputChange(e) {
    let nodeName = e.target.name;

    if (nodeName === "fleetManager") {
      this.state.shipData.shipUsers.push({
        userName: e.target.value,
        role: "fleetmanager",
      });
      this.state[nodeName] = e.target.value;
    } else if (nodeName === "superintendent") {
      this.state.shipData.shipUsers.push({
        userName: e.target.value,
        role: "superintendent",
      });
      this.state[nodeName] = e.target.value;
    } else if (nodeName === "technicalExecutive") {
      this.state.shipData.shipUsers.push({
        userName: e.target.value,
        role: "technicalexecutive",
      });
      this.state[nodeName] = e.target.value;
    } else if (nodeName === "companyName") {
      this.props.dispatch(getClientUsersList(e.target.value));
      this.state.shipData[nodeName] = e.target.value;
      this.state.fleetManager = "";
      this.state.superintendent = "";
      this.state.technicalExecutive = "";
      this.state.shipData.shipUsers = [];
    } else {
      this.state.shipData[nodeName] = e.target.value;
    }
    this.setState({});
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    if (nodeName === "HKC") {
      this.state.hkcFilename = e.target.files[0].name;
      this.state.hkcfile = e.target.files[0];
      this.setState({});
    } else if (nodeName === "EUSSR") {
      this.state.eussrFilename = e.target.files[0].name;
      this.state.eussrfile = e.target.files[0];
      this.setState({});
    } else {
      this.state.shipData[nodeName] = e.target.value;
      this.setState({});
    }
  }

  handleCheckBoxChange(e) {
    if (e.target.checked) {
      this.setState(prevState => ({
        shipData: {
          ...prevState.shipData,
          isActive: true
        }
      }));
    }
    else {
      this.setState(prevState => ({
        shipData: {
          ...prevState.shipData,
          isActive: false
        }
      }));
    }
  }
  handleCheckBoxChange1(e) {
    if (e.target.checked) {
      this.setState(prevState => ({
        shipData: {
          ...prevState.shipData,
          isActive: false
        }
      }));
    }
    else {
      this.setState(prevState => ({
        shipData: {
          ...prevState.shipData,
          isActive: true
        }
      }));
    }
  }

  openHKCFromDatePicker() {
    this.setState({
      hkcFromDateOpen: !this.state.hkcFromDateOpen,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      eussrToDateOpen: false,
    });
  }

  openEUSSRFromDatePicker() {
    this.setState({
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: !this.state.eussrFromDateOpen,
      eussrToDateOpen: false,
    });
  }

  openHKCToDatePicker() {
    this.setState({
      hkcFromDateOpen: false,
      hkcToDateOpen: !this.state.hkcToDateOpen,
      eussrFromDateOpen: false,
      eussrToDateOpen: false,
    });
  }

  openEUSSRToDatePicker() {
    this.setState({
      hkcFromDateOpen: false,
      hkcToDateOpen: false,
      eussrFromDateOpen: false,
      eussrToDateOpen: !this.state.eussrToDateOpen,
    });
  }

  handleHKCFromDateChange(date) {
    this.state.shipData.hkcIssuedDate = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      hkcFromDateOpen: false,
    });
  }

  handleHKCToDateChange(date) {
    if (
      Moment(new Date(Date.parse(date))).format("YYYY-MM-DD") >=
      this.state.shipData.hkcIssuedDate
    ) {
      this.state.shipData.hkcExpiryDate = Moment(
        new Date(Date.parse(date))
      ).format("YYYY-MM-DD");
    } else {
      //  swal('Error!', 'To date must greater than from date ', 'warning');
    }
    this.setState({
      hkcToDateOpen: false,
    });
  }

  handleEUSSRFromDateChange(date) {
    this.state.shipData.euSSRIssuedDate = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      eussrFromDateOpen: false,
    });
  }

  handleEUSSRToDateChange(date) {
    if (
      Moment(new Date(Date.parse(date))).format("YYYY-MM-DD") >=
      this.state.shipData.euSSRIssuedDate
    ) {
      this.state.shipData.euSSRExpiryDate = Moment(
        new Date(Date.parse(date))
      ).format("YYYY-MM-DD");
    } else {
      //  swal('Error!', 'To date must greater than from date ', 'warning');
    }
    this.setState({
      eussrToDateOpen: false,
    });
  }

  ClearHKC = () => {
    this.setState({
      hkcFilename: "",
      hkcfile: "",
    });
  };

  ClearEUSSR = () => {
    this.setState({
      eussrfile: "",
      eussrFilename: "",
    });
  };

  handlePaintCoatingPageChange(event) {
    this.setState({
      activePagePaintCoating: event.first,
    });
  }

  handleEquipmentPageChange(event) {
    this.setState({
      activePageEquipment: event.first,
    });
  }

  handleStructurePageChange(event) {
    this.setState({
      activePageStructure: event.first,
    });
  }

  handleStoresPageChange(event) {
    this.setState({
      activePageStore: event.first,
    });
  }
  BacktoPrevious() {
    this.props.history.goBack();
  }

  render() {
    const {
      showSidePane,
      ClientUsersList,
      ClientNameList,
      fleetManagerList,
      TechExecutiveList,
      TechSuperintendentList,
    } = this.props;
    console.log("companyName", this.state.shipData.companyName);

    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row px-3 pb-3">
            <button
              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
              onClick={() => this.BacktoPrevious()}
            >
              <div style={{ position: 'relative' }}>
                <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Back</span>
              </div>
            </button>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="panel-box">
                <div
                  className="card mt-2 MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}
                  >
                    <h5
                      className="card-title ml-1 pl-3 mt-2"
                      style={{ color: "092a51" }}
                    >
                      Basic Details
                    </h5>
                  </div>
                </div>
                <div className="row search-filter-box">
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label required">Ship Name</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="shipName"
                      placeholder="Ship Name"
                      value={this.state.shipData.shipName}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label required">IMO No</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="imoNo"
                      placeholder="IMO No"
                      value={this.state.shipData.imoNo}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label required">Ship Email</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="shipEmail"
                      placeholder="Ship Email"
                      value={this.state.shipData.shipEmail}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">
                      Vessel Group Email{" "}
                      <span className="font-weight-normal">(Optional)</span>
                    </label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="vesselGroupEmail"
                      placeholder="Vessel Group Email"
                      value={this.state.shipData.vesselGroupEmail}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">Is Active</label>
                    <br></br>
                    <div className="d-flex align-items-center">
                      <input
                        style={{ height: '20px', width: '20px' }}
                        type="checkbox"
                        name="isAdmin"
                        id="activeyes"
                        className="mr-2"
                        checked={this.state.shipData.isActive}
                        onChange={(e) => this.handleCheckBoxChange(e)}
                      ></input>
                      <label htmlFor="activeyes" className="form-label mr-3">Yes</label>
                      <input
                        style={{ height: '20px', width: '20px' }}
                        type="checkbox"
                        name="isAdminno"
                        id="activeno"
                        className="mr-2"
                        checked={!this.state.shipData.isActive}
                        onChange={(e) => this.handleCheckBoxChange1(e)}
                      ></input>
                      <label htmlFor="activeno" className="form-label">No</label>
                    </div>
                  </div>
                </div>
                <div
                  className="card MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}
                  >
                    <h5
                      className="card-title ml-1 pl-3 mt-2"
                      style={{ color: "092a51" }}
                    >
                      Company Details
                    </h5>
                  </div>
                </div>
                <div className="row search-filter-box">
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label required">Client Name</label>
                    <br></br>
                    <select
                      className="form-control"
                      name="companyName"
                      value={this.state.shipData.companyName}
                      onChange={(e) => this.handleCompanyInputChange(e)}
                    >
                      <option value="">Select Company Name</option>
                      {ClientNameList &&
                        ClientNameList.map((i) => (
                          <option value={i.clientName}>{i.clientName}</option>
                        ))}
                    </select>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">Marine Manager</label>
                    <br></br>
                    <select
                      className="form-control"
                      name="fleetManager"
                      value={this.state.fleetManager}
                      onChange={(e) => this.handleCompanyInputChange(e)}
                    >
                      <option value="">Select Marine Manager</option>
                      {fleetManagerList ? (
                        fleetManagerList.map((i) => (
                          <option value={i.userName}>{i.userName}</option>
                        ))
                      ) : (
                        <option value=""></option>
                      )}
                    </select>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">
                      Marine Superintendent
                    </label>
                    <br></br>
                    <select
                      className="form-control"
                      name="superintendent"
                      value={this.state.superintendent}
                      onChange={(e) => this.handleCompanyInputChange(e)}
                    >
                      <option value="">Marine Superintendent</option>
                      {TechSuperintendentList ? (
                        TechSuperintendentList.map((i) => (
                          <option value={i.userName}>{i.userName}</option>
                        ))
                      ) : (
                        <option value=""></option>
                      )}
                    </select>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">DPA</label>
                    <br></br>
                    <select
                      className="form-control"
                      name="technicalExecutive"
                      value={this.state.technicalExecutive}
                      onChange={(e) => this.handleCompanyInputChange(e)}
                    >
                      <option value="">DPA</option>
                      {TechExecutiveList ? (
                        TechExecutiveList.map((i) => (
                          <option value={i.userName}>{i.userName}</option>
                        ))
                      ) : (
                        <option value=""></option>
                      )}
                    </select>
                  </div>
                </div>
                <div className="pb-4 pl-4 pr-4">
                  <div className="search-btn-col" style={{ textAlign: "end" }}>
                    <button
                      className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                      type="submit"
                      onClick={() => this.UpdateData()}
                    >
                      {" "}
                      Update{" "}
                    </button>
                    <button
                      className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                      type="button"
                      onClick={() => this.CancelUpdateship()}
                    >
                      {" "}
                      Cancel{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  EditMaterials(id, item) {
    const { match } = this.props;
    this.props.dispatch({ type: "EditMaterial", data: true });
    this.props.dispatch({ type: "ShowSidePan", data: true });
    if (id === 1) {
      this.props.dispatch({ type: "GetPaintCoatingDetails", data: item });
      this.props.history.push(
        `/Home/Management/ShipEdit/${match.params.id}/PaintCoating`
      );
    } else if (id === 2) {
      this.props.dispatch({ type: "GetEquipmentMachineryDetails", data: item });
      this.props.history.push(
        `/Home/Management/ShipEdit/${match.params.id}/EquipmentMachinery`
      );
    } else if (id === 3) {
      this.props.dispatch({ type: "GetStructureHullDetails", data: item });
      this.props.history.push(
        `/Home/Management/ShipEdit/${match.params.id}/StructureHull`
      );
    } else if (id === 4) {
      this.props.dispatch({ type: "GetStoreDetails", data: item });
      this.props.history.push(
        `/Home/Management/ShipEdit/${match.params.id}/Stores`
      );
    }
    window.scrollTo(0, 0);
  }

  showRightPanel(id) {
    const { match } = this.props;
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.dispatch({ type: "EditMaterial", data: false });
    if (id === 1) {
      this.props.dispatch({ type: "GetPaintCoatingDetails", data: null });
      this.props.history.push(
        `/Home/Management/ShipEdit/${match.params.id}/PaintCoating`
      );
    } else if (id === 2) {
      this.props.dispatch({ type: "GetEquipmentMachineryDetails", data: null });
      this.props.history.push(
        `/Home/Management/ShipEdit/${match.params.id}/EquipmentMachinery`
      );
    } else if (id === 3) {
      this.props.dispatch({ type: "GetStructureHullDetails", data: null });
      this.props.history.push(
        `/Home/Management/ShipEdit/${match.params.id}/StructureHull`
      );
    } else if (id === 4) {
      this.props.dispatch({ type: "GetStoreDetails", data: null });
      this.props.history.push(
        `/Home/Management/ShipEdit/${match.params.id}/Stores`
      );
    }
    window.scrollTo(0, 0);
  }
  showEquipmentSidePane() {
    this.props.dispatch({ type: "editEquipment", data: false });
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.history.push("/Home/Management/ShipEdit/Equipment");
  }
  EditEquipment() {
    this.props.dispatch({ type: "editEquipment", data: true });
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.history.push("/Home/Management/ShipEdit/Equipment");
  }

  moveClientList = () => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/Management/Ship");
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    ShipDetails: state.MasterScreenReducer.ShipDetails,
    fleetManagerList: state.MasterScreenReducer.fleetManagerList,
    TechSuperintendentList: state.MasterScreenReducer.techSuperintendentList,
    TechExecutiveList: state.MasterScreenReducer.techExecutiveList,
    ClientUsersList: state.MasterScreenReducer.ClientUsersList,
    ClientNameList: state.UserManageReducer.CompanyList,
    companyName: state.MasterScreenReducer.companyName,
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShipManagementEditItem)
);
